<template>
  <div class="dynamic-field-container">
    <label>{{ field.label }}</label>
    <el-input
      data-vv-validate-on="input"
      clearable
      :name="fieldName"
      :data-vv-as="fieldName"
      class="fifty-percent"
      v-model="proxyValue"
      v-validate="fieldValidationRules"
      :placeholder="field.placeholder"
      :disabled="isTaskFieldDisabled"
      :value="field.value">
    </el-input>
    <small class="text-danger" v-show="errors.has(fieldName)" style="display: block; margin-top: 7px;">
      {{ field.label }} must be an integer (1, 2, 5) or a decimal in quarter hour increments (1.25, 3.5, 8.75)
    </small>
  </div>
</template>

<script>
  import {generateDynamicFieldValidation, canEditTaskField, ucFirst} from 'src/utilities/utils'

  export default {
    inject: ['$validator'],
    props: ['field', 'value', 'commit', 'task', 'disabled'],
    fieldName: 'temp',
    computed: {
      fieldValidationRules () {
        // expressions override other validation logic
        if (this.field.expression) {
          this.fieldValidation = function(str) {
            return eval(str).apply(this)
          }.call(this, this.field.expression)
        }
        return this.fieldValidation
      },
      proxyValue: {
        get() {
          return this.value
        },
        set(newValue) {
          this.$store.commit(this.commit, { key: this.field.key, value: newValue })
        }
      },
      isTaskFieldDisabled() {
        if (this.disabled) {
          return true
        }
        return !canEditTaskField(this)
      }
    },
    data() {
      return {
        fieldValidation: { },
        statusOnLoad: null,
        ucFirst: ucFirst
      }
    },
    beforeMount() {
      generateDynamicFieldValidation(this)
      this.statusOnLoad = JSON.parse(JSON.stringify(this.task.status))
    }
  }
</script>

<style scoped>
  label {
    display: block;
  }
  .dynamic-field-container {
    margin-bottom: 10px;
  }
  .fifty-percent {
    width: 50%
  }
</style>
